import React from "react";

interface ConnectionLineProps {
  from: { x: number; y: number };
  to: { x: number; y: number };
  selected?: boolean;
}

export const ConnectionLine: React.FC<ConnectionLineProps> = ({ 
  from, 
  to, 
  selected = false
}) => {
  const centerX = from.x + 64;
  const centerY = from.y + 48;
  const nextCenterY = to.y + 20;

  const strokeColor = selected ? "#10b981" : "#9ca3af";
  const strokeWidth = selected ? 3 : 2;

  return (
    <svg
      className="absolute pointer-events-none z-0"
      style={{ top: 0, left: 0, width: "100%", height: "100%" }}
    >
      {/* Main connection line */}
      <line
        x1={centerX}
        y1={centerY}
        x2={centerX}
        y2={nextCenterY}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeDasharray={selected ? "none" : "5,5"}
      />
      
      {/* Connection dot at the end */}
      <circle
        cx={centerX}
        cy={nextCenterY}
        r="4"
        fill={strokeColor}
      />
    </svg>
  );
};